import { useEffect, useState } from "react";

function useStartupOnlineCheck(): boolean | null {
  const [initialOnline, setInitialOnline] = useState<boolean | null>(null);

  useEffect(() => {
    async function checkStartupOnline() {
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 3000);

        await fetch('https://www.google.com/favicon.ico', {
          method: 'HEAD',
          mode: 'no-cors',
          signal: controller.signal,
        });

        clearTimeout(timeout);
        setInitialOnline(true);
      } catch {
        setInitialOnline(false);
      }
    }

    checkStartupOnline();
  }, []);

  return initialOnline;
}

export default useStartupOnlineCheck